<template>
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M8.3704 11.5361C7.81634 10.1541 7.75643 8.62314 8.20082 7.20207C8.64521 5.781 9.56662 4.55694 10.8093 3.73681C12.052 2.91668 13.5398 2.55077 15.0211 2.70093C16.5025 2.8511 17.8865 3.50813 18.9394 4.56097C19.9922 5.6138 20.6492 6.99787 20.7994 8.47921C20.9495 9.96055 20.5836 11.4483 19.7635 12.691C18.9434 13.9337 17.7193 14.8551 16.2982 15.2995C14.8772 15.7439 13.3462 15.684 11.9642 15.1299L11.9643 15.1298L10.7812 16.3128H8.625V18.4691H6.46875V20.6253H2.875V17.0316L8.37056 11.536L8.3704 11.5361Z"
      fill="white"
    />
    <path
      d="M8.3704 11.5361C7.81634 10.1541 7.75643 8.62314 8.20082 7.20207C8.64521 5.781 9.56662 4.55694 10.8093 3.73681C12.052 2.91668 13.5398 2.55077 15.0211 2.70093C16.5025 2.8511 17.8865 3.50813 18.9394 4.56097C19.9922 5.6138 20.6492 6.99787 20.7994 8.47921C20.9495 9.96055 20.5836 11.4483 19.7635 12.691C18.9434 13.9337 17.7193 14.8551 16.2982 15.2995C14.8772 15.7439 13.3462 15.684 11.9642 15.1299L11.9643 15.1298L10.7812 16.3128H8.625V18.4691H6.46875V20.6253H2.875V17.0316L8.37056 11.536L8.3704 11.5361Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      opacity="0.5"
      d="M16.1719 7.6875C16.3704 7.6875 16.5312 7.5266 16.5312 7.32812C16.5312 7.12965 16.3704 6.96875 16.1719 6.96875C15.9734 6.96875 15.8125 7.12965 15.8125 7.32812C15.8125 7.5266 15.9734 7.6875 16.1719 7.6875Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.1719 8.40625C16.7673 8.40625 17.25 7.92356 17.25 7.32812C17.25 6.73269 16.7673 6.25 16.1719 6.25C15.5764 6.25 15.0938 6.73269 15.0938 7.32812C15.0938 7.92356 15.5764 8.40625 16.1719 8.40625Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  name: "KeyPassIcon",
  props: {
    color: {
      type: String,
      default: "#007acc",
    },
  },
}
</script>
